import HamburgerMenu from './lib/menu';
import { VideoPlayer } from './lib/video';

import './scss/core.scss';

HamburgerMenu.createFromSelectors('#hamburger', '#popup-menu', '#header');
VideoPlayer.createFromSelector('.js-video-player');
